import { CoreApi } from '@inter-ikea-storageone/range';
import { AnalyticsPayload } from '../AnalyticsEvent';
import { ComponentIds, Entity, HierarchyUtils, Vector } from '@inter-ikea-core/core';
import { CornerSolutionComponent } from '@inter-ikea-storageone/range';
import { IpexMomentEnum } from '@insights/insights-data-provider';

type SceneArticle = {
  articleNumber?: string;
  frameId?: number;
  id: number;
  position: Vector;
  rotation: Vector;
  isSelected: boolean;
  isFrame: boolean;
  isFrameSelected: boolean;
};

export const isEntityFrame = (entity: Entity) =>
  entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID) ||
  entity.hasComponent(CornerSolutionComponent.id);

export const getEntityFrame = (entity: Entity) =>
  isEntityFrame(entity)
    ? entity
    : HierarchyUtils.findWithComponentInUpwardsHierarchy(entity, CornerSolutionComponent.id) ||
      HierarchyUtils.findWithComponentInUpwardsHierarchy(entity, ComponentIds.FRAME_COMPONENT_ID);

const withSceneArticles = <T extends AnalyticsPayload>(
  payload: T,
  coreApi: CoreApi,
  ipexMoment: IpexMomentEnum
): T & { articlesInScene?: SceneArticle[] } => {
  if (ipexMoment !== IpexMomentEnum.makeItMe) return payload;

  let articlesInScene = [] as SceneArticle[];

  // coreApi might be a NoCore reference from useCore
  try {
    const allEntities = coreApi.entities.getAll();

    const selectedEntity = coreApi.entities.findSelectedEntity();

    articlesInScene = allEntities.map(entity => ({
      articleNumber: coreApi.entities.getGlobalArticleNumber(entity),
      frameId: getEntityFrame(entity)?.id,
      id: entity.id,
      isFrame: isEntityFrame(entity),
      isFrameSelected: !!selectedEntity && selectedEntity?.id === getEntityFrame(entity)?.id,
      rotation: coreApi.entities.getWorldRotation(entity).toEulerDegrees(),
      position: coreApi.entities.getWorldPosition(entity),
      isSelected: selectedEntity?.id === entity.id
    }));
    // eslint-disable-next-line no-empty
  } catch {}

  // Verbose property name to not overwrite properties
  return {
    ...payload,
    articlesInScene
  };
};

export default withSceneArticles;
